module.exports = __webpack_public_path__ + "static/media/share-7you.8368e4b7.png";